import { AntdTheme } from '@copilot/common/config';
import ImpersonatorInformationPanel from '@copilot/common/pages/adminHub/ImpersonatorInformationPanel';
import { ProspectingToolHeaderContainer } from '@copilot/common/pages/layouts/headerSider/header/prospectingToolHeader';
import { AuthenticatedTemplate } from '@copilot/common/utils/authenticationProvider';
import { ConfigProvider, Layout } from 'antd';
import { PropsWithChildren, useEffect, useState } from 'react';
import { BaseAppSideBar } from './sideBar/baseAppSideBar';
import ModalManager from '@copilot/common/components/modals/manager';
import DrawerContainerManager from '@copilot/common/components/drawer';
import styles from './headerSider.module.less';
import { useTheme } from 'styled-components';
import { matchPath, useLocation } from 'react-router-dom';

/**
 * Base app layout for the prospecting app, includes header sider and main content area as well as an outlet for notifications
 * @param children - The children to render
 * @returns The base app layout
 */
export function BaseAppLayout({ children }: PropsWithChildren<{}>) {
    const theme = useTheme();
    const location = useLocation();
    const [isCollapsed, setIsCollapsed] = useState(false);

    /**
     * Effect to collapse the sider when on campaign details page.
     */
    useEffect(() => {
        const match = matchPath('/campaign/:campaignId', location.pathname);
        setIsCollapsed(match ? true : false);
    }, [location]);

    return (
        <ConfigProvider prefixCls="copilot" theme={AntdTheme}>
            <AuthenticatedTemplate>
                <Layout className={styles.headerSiderWrapper}>
                    <ImpersonatorInformationPanel />
                    <Layout.Header>
                        <ProspectingToolHeaderContainer />
                    </Layout.Header>
                    <Layout>
                        <Layout.Sider
                            theme="light"
                            width={theme['@layout-sider-width']}
                            className={styles.siderWrapper}
                            collapsed={isCollapsed}
                        >
                            <BaseAppSideBar
                                setIsCollapsed={setIsCollapsed}
                                isCollapsed={isCollapsed}
                            />
                        </Layout.Sider>
                        <Layout.Content className={styles.contentWrapper}>
                            {children}
                            <ModalManager />
                            <DrawerContainerManager />
                        </Layout.Content>
                    </Layout>
                </Layout>
            </AuthenticatedTemplate>
        </ConfigProvider>
    );
}
